<template>
    <div class="cont-tit">
        <h2 class="page-title">IT Innovation Company, <span class="c-red">OSANG TECHNOLOGY</span></h2>
        <p class="page-desc">
            Since its establishment in 2007, Osang Technology Co., Ltd. has been gradually expanding its business into the O2O service field. <br>
            Based on the solutions and best IT service know-how accumulated through various projects, we are always actively working to ensure our customers' successful business. <br>
            We support your business with a simple and secure platform.
        </p>
    </div>
    <div class="osang-technology">
        <div class="cont-tit">
            <h2 class="page-title">WHO’s OSANG?</h2>
        </div>
        <div class="osang-technology__text">
            <ul class="osang-technology__text-list">
                <li class="osang-technology__text-item">
                    <img src="../../assets/resource/icon/technology-icon01.svg" alt="">
                    <h3 class="osang-technology__text-tit">In-Depth Task Understanding</h3>
                    <ul>
                        <li>Expertise in understanding system DB structures from similar projects</li>
                        <li>Smooth communication with field managers to ensure project alignment</li>
                        <li>Extensive experience in middleware system maintenance</li>
                    </ul>
                </li>
                <li class="osang-technology__text-item">
                    <img src="../../assets/resource/icon/technology-icon02.svg" alt="">
                    <h3 class="osang-technology__text-tit">Proven Experience and Capabilities</h3>
                    <ul>
                        <li>Successful management of e-commerce mobile business projects</li>
                        <li>Expertise in O2O system development and implementation</li>
                        <li>Strong background in B2B/B2C CTM middleware projects</li>
                    </ul>
                </li>
                <li class="osang-technology__text-item">
                    <img src="../../assets/resource/icon/technology-icon03.svg" alt="">
                    <h3 class="osang-technology__text-tit">Strategic Planning and Execution</h3>
                    <ul>
                        <li>Maximize collaboration with specialized advisory teams across various field.</li>
                        <li>Boost efficiency, reduce uncertainty, and ensure high-quality, customized services.</li>
                        <li>Leverage expertise from managing our own B2C operations.</li>
                    </ul>
                </li>
            </ul>
        </div>

        <div class="cont-tit">
            <h2 class="page-title">CERTIFIED</h2>
        </div>
        <div class="osang-technology__certified">
            <ul class="osang-technology__certified-list">
                <li class="osang-technology__certified-item">
                    <img src="../../assets/resource/img/certified-img04.png" alt="">
                    <p>Competitiveness based on technological superiority <br>
                        Secured innovative small and medium enterprises.</p>
                </li>
                <li class="osang-technology__certified-item">
                    <img src="../../assets/resource/img/certified-img05.png" alt="">
                    <p>technological innovation and business <br>
                        A company with excellent growth potential</p>
                </li>
                <li class="osang-technology__certified-item">
                    <img src="../../assets/resource/img/certified-img06.png" alt="">
                    <p>through management innovation activities <br>
                        Small and medium-sized businesses with new growth engines</p>
                </li>
            </ul>
        </div>

        <div class="cont-tit">
            <h2 class="page-title">CLIENT</h2>
        </div>

        <div class="client">
            <ul class="client__list">
                <li class="client__item" v-for="(item, index) in 36" :key="index">
                    <img :src="require(`@/assets/resource/img/client-img${index + 1}.png`)" alt="">
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>
<style>

</style>